module.exports = __webpack_public_path__ + "static/media/leadBundle3.e2b65a9c.svg";